import { RxDashboard } from "react-icons/rx";
import { BsClipboardData } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import { MdOutlineCampaign, MdOutlineMoodBad, MdOutlinePayments } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { FiUser } from "react-icons/fi";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { ImLab } from "react-icons/im";
import { IoSearchOutline } from "react-icons/io5";
import { TbUsers } from "react-icons/tb"
import { FaRegHeart } from "react-icons/fa6";

export const links = [
    // {
    //     title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
    //     Icon: RxDashboard,
    //     links: [
    //         {
    //             title: <FormattedMessage id="Tickets" defaultMessage={"Tickets"} />,
    //             Icon: FiUser,
    //             to: "/tickets",
    //         }
    //     ]
    // },
    {
        title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
        Icon: RxDashboard,
        to: "/",
    },
    {
        title: <FormattedMessage id="discovery" defaultMessage={"Discovery"} />,
        Icon: IoSearchOutline,
        to: "/discovery",
    },
    {
        title: <FormattedMessage id="campaign" defaultMessage={"Campaign"} />,
        Icon: MdOutlineCampaign,
        to: "/campaign",
    },
    {
        title: <FormattedMessage id="my_influencers" defaultMessage={"My Influencers"} />,
        Icon: TbUsers,
        to: "/influencers",
    },
    {
        title: <FormattedMessage id="profile" defaultMessage={"Profile"} />,
        Icon: FiUser,
        to: "/profile",
    },
    {
        title: <FormattedMessage id="subscription" defaultMessage={"Subscription"} />,
        Icon: MdOutlinePayments,
        to: "/subscription",
    },
    {
        title: <FormattedMessage id="favorite_influencers" defaultMessage={"Favorite Influencers"} />,
        Icon: FaRegHeart,
        to: "/favorite-influencers",
    },
     
    
]